import { useParams } from "react-router-dom";
import SingleHistory from "../components/Blog/SingleHistory";

function SingleHistoryPage() {
	const { id } = useParams();
	return (
		<main style={{ overflowX: "hidden" }}>
			<div className="container my-4">
				<SingleHistory id={id} />
			</div>
		</main>
	);
}
export default SingleHistoryPage;
